import React, { Component } from "react";
import { Switch, Route, Redirect } from 'react-router' // react-router v4
import LoginRoute from './routes/LoginRoute';
import SignUpRoute from './routes/SignUpRoute';
import VerificationRoute from './routes/VerificationRoute';
import UserRoute from './routes/UserRoute';
import AdminRoute from './routes/AdminRoute';
import Dashboard from './components/Dashboard';
import Pagination from 'react-js-pagination'

import { connect } from "react-redux";
import { confirmToken } from "./actions/userActions";
import FrontPageContainer from "./containers/FrontPageContainer";

class App extends Component {

    componentDidMount() {
        this.props.verifyToken();
    }

    render() {
        return (
            <div>
                <Switch>
                    <Route path="/" exact component={FrontPageContainer}/>
                    <Route path="/admin" exact component={AdminRoute}/>
                    <Route path="/login" exact component={LoginRoute}/>
                    <Route path="/signup" component={SignUpRoute}/>
                    <Route path="/verification" component={VerificationRoute}/>
                    <Route path="/user" component={UserRoute}/>
                    <Route path="/dashboard" component={Dashboard}/>
                    <Redirect to="/"/>
                </Switch>
            </div>
        )
    }

}

export default connect(
    state => ({
        loggedIn: state.user.bearerToken ? true : false,
        route: state.router.location.pathname // Re-renders the component when route changes
    }),
    dispatch => ({
        verifyToken: () => dispatch( confirmToken() )
    })
)( App );
